export default {"src":"/_next/static/image/public/images/ic_new_decrease_product.06bab2b985aacedeb38683a3be7e3189.svg","height":34,"width":35};